import { render, staticRenderFns } from "./customerNewCRM.vue?vue&type=template&id=32930c5e"
import script from "./customerNewCRM.vue?vue&type=script&lang=js"
export * from "./customerNewCRM.vue?vue&type=script&lang=js"
import style0 from "./customerNewCRM.vue?vue&type=style&index=0&id=32930c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports